"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formik = require("formik");
require("./DatePicker.scss");
var _Input = _interopRequireDefault(require("../Input/Input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var YYYY_MM_DD = 'YYYY-MM-DD';
var timeZone = 'America/Mexico_City';
var DatePicker = function DatePicker(props) {
  var initialValue = props.initialValue,
    disabled = props.disabled,
    name = props.name,
    onChange = props.onChange,
    calendarTop = props.calendarTop,
    _props$initialYear = props.initialYear,
    initialYear = _props$initialYear === void 0 ? new Date().getFullYear() : _props$initialYear,
    _props$numberYears = props.numberYears,
    numberYears = _props$numberYears === void 0 ? 12 : _props$numberYears;
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var calendarRef = (0, _react.useRef)(null);
  var setValue = helpers.setValue;
  var days = (0, _react.useMemo)(function () {
    return Array.from({
      length: 31
    }, function (_, i) {
      return i + 1;
    });
  });
  var months = (0, _react.useMemo)(function () {
    return ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  });
  var years = (0, _react.useMemo)(function () {
    return Array.from({
      length: numberYears
    }, function (_, i) {
      return initialYear + 1 - i;
    });
  });
  var _useState = (0, _react.useState)('day'),
    _useState2 = _slicedToArray(_useState, 2),
    activeSelection = _useState2[0],
    setActiveSelection = _useState2[1];
  var _useState3 = (0, _react.useState)('día'),
    _useState4 = _slicedToArray(_useState3, 2),
    daySelected = _useState4[0],
    setDaySelected = _useState4[1];
  var _useState5 = (0, _react.useState)('mes'),
    _useState6 = _slicedToArray(_useState5, 2),
    monthSelected = _useState6[0],
    setMonthSelected = _useState6[1];
  var _useState7 = (0, _react.useState)('año'),
    _useState8 = _slicedToArray(_useState7, 2),
    yearSelected = _useState8[0],
    setYearSelected = _useState8[1];
  var _useState9 = (0, _react.useState)(days),
    _useState10 = _slicedToArray(_useState9, 2),
    calendarElements = _useState10[0],
    setCalendarElements = _useState10[1];
  var _useState11 = (0, _react.useState)('día'),
    _useState12 = _slicedToArray(_useState11, 2),
    currentTitle = _useState12[0],
    setCurrentTitle = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    open = _useState14[0],
    setOpen = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    hasContent = _useState16[0],
    setHasContent = _useState16[1];
  var handleSelection = (0, _react.useCallback)(function (value) {
    if (activeSelection === 'day') {
      setDaySelected(value);
      setActiveSelection('month');
      setCalendarElements(months);
      setCurrentTitle('mes');
    } else if (activeSelection === 'month') {
      setMonthSelected(months.indexOf(value));
      setActiveSelection('year');
      setCalendarElements(years);
      setCurrentTitle('año');
    } else {
      setYearSelected(value);
      setActiveSelection('day');
      setCalendarElements(days);
      setCurrentTitle('día');
      setOpen(false);
    }
  }, [activeSelection, years, days, months]);
  (0, _react.useEffect)(function () {
    if (daySelected !== 'día' || monthSelected !== 'mes' || yearSelected !== 'año') {
      setHasContent(true);
    } else {
      setHasContent(false);
    }
    if (daySelected !== 'día' && monthSelected !== 'mes' && yearSelected !== 'año') {
      var realMonth = monthSelected + 1;
      var month = realMonth >= 10 ? realMonth : "0".concat(realMonth);
      var day = daySelected >= 10 ? daySelected : "0".concat(daySelected);
      setValue("".concat(yearSelected, "-").concat(month, "-").concat(day));
    }
  }, [yearSelected, daySelected, monthSelected]);
  var toogleOpen = (0, _react.useCallback)(function () {
    setOpen(!open);
  }, [open]);
  var handleCalendarClick = (0, _react.useCallback)(function () {
    if (!disabled) {
      toogleOpen();
    }
  });
  var handleOpen = (0, _react.useCallback)(function () {
    setOpen(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (initialValue) {
      var propsDate = (0, _momentTimezone["default"])(initialValue, YYYY_MM_DD).tz(timeZone).toDate();
      setDaySelected(propsDate.getDate());
      setMonthSelected(propsDate.getMonth());
      setYearSelected(propsDate.getFullYear());
    } else {
      setDaySelected('día');
      setMonthSelected('mes');
      setYearSelected('año');
    }
  }, [initialValue]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setTimeout(function () {
      var target = document.activeElement;
      var focusedElement = target ? target.id || target || target.tagName : '';
      var isFocusedCalendar = focusedElement.className.indexOf('DatePickerV1__calendar--open') !== -1;
      setOpen(isFocusedCalendar);
      if (props.onBlur) {
        props.onBlur(e);
      }
    }, 1);
  });
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    event.preventDefault();
  }, []);
  (0, _react.useEffect)(function () {
    if (onChange) {
      onChange(field.value);
    }
  }, [field.value]);

  // Starts classNames block
  var containerCN = (0, _classnames["default"])('DatePickerV1__input', {
    'DatePickerV1__input--open': open
  });
  var calendarCN = (0, _classnames["default"])(calendarTop && 'DatePickerV1__calendarTop', "DatePickerV1__calendar", {
    'DatePickerV1__calendar--open': open
  });
  var iconCn = (0, _classnames["default"])("svg-icon svg-icon-calendar");
  var noValues = daySelected === 'día' && monthSelected === 'mes' && yearSelected === 'año';
  var dayFormatted = daySelected === 'día' || daySelected >= 10 ? daySelected : "0".concat(daySelected);
  var monthFormatted = months[monthSelected] ? months[monthSelected] : 'mes';
  var finalValue = noValues ? '' : "".concat(dayFormatted, " / ").concat(monthFormatted, " / ").concat(yearSelected);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "DatePickerV1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: containerCN
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    label: props.label
  }, field, {
    type: "text",
    value: finalValue,
    placeholder: props.placeholder,
    modifiedExternal: hasContent,
    name: props.name,
    id: props.id,
    disabled: disabled,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    right: /*#__PURE__*/_react["default"].createElement("div", {
      onBlur: handleBlur,
      onClick: handleCalendarClick,
      tabIndex: "-1",
      className: iconCn
    }),
    onFocus: handleOpen,
    inputClass: calendarTop
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: -1,
    ref: calendarRef,
    onBlur: function onBlur(e) {
      setOpen(false);
      if (props.onBlur) {
        props.onBlur(_objectSpread(_objectSpread({}, e), {}, {
          dateValue: field.value
        }));
      }
    },
    className: calendarCN
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "col-form-label"
  }, "Selecciona un ", currentTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "DatePickerV1__calendar__".concat(activeSelection, "s-grid")
  }, calendarElements && calendarElements.map(function (element) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "".concat(activeSelection, "-").concat(element),
      onClick: function onClick() {
        return handleSelection(element);
      },
      className: (0, _classnames["default"])('DatePickerV1__calendar__element', {
        'DatePickerV1__calendar__element--selected': element === daySelected || element === months[monthSelected] || element === yearSelected
      })
    }, activeSelection === 'day' ? element >= 10 ? element : "0".concat(element) : element);
  }))));
};
DatePicker.propTypes = {
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
DatePicker.defaultProps = {};
var _default = exports["default"] = DatePicker;